import React from 'react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section className="bg-dark py-20 px-4 border-t border-gray-800" data-id="element-95">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-96">
        <h2 className="md:text-5xl font-bold text-white mb-10 text-[28px]" data-id="element-97">
          Juega Desde Otro Nivel
        </h2>

        <img src="https://cdn.magicpatterns.com/uploads/eK29QbrjVKuC2qtWSCW7dw/Mock_Up_Juega_desde_Otro_Nivel.jpg" alt="Mock up Juega Desde Otro Nivel" className="w-full max-w-[700px] mx-auto mb-12 rounded-xl" data-id="element-98" />

        <div className="text-xl md:text-2xl text-white mb-12 space-y-4 font-medium" data-id="element-99">
          <p data-id="element-100">90 minutos para ordenar cómo creces.</p>
          <p data-id="element-101">En vivo por Zoom</p>
          <p data-id="element-102">Sábado 18 de abril de 2026</p>
          <p data-id="element-103">10:00 a. m. Venezuela</p>
          <p className="text-accent font-bold text-3xl mt-6" data-id="element-104">
            Inversión: $15 USD
          </p>
        </div>

        <p className="text-lg md:text-xl text-white mb-10 max-w-2xl" data-id="element-105">
          Vas a salir con más claridad, más criterio y decisiones concretas para
          dejar de operar en automático.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-106">
          QUIERO ENTRAR A LA SESIÓN
        </CTAButton>
      </div>
    </section>;
}